module.exports = __webpack_public_path__ + "img/contacto_16-9_640.06f803eb.webp";